import { render } from "./GenerateFlashQuestionModal.vue?vue&type=template&id=3acdac13&scoped=true"
import script from "./GenerateFlashQuestionModal.vue?vue&type=script&lang=js"
export * from "./GenerateFlashQuestionModal.vue?vue&type=script&lang=js"

import "./GenerateFlashQuestionModal.vue?vue&type=style&index=0&id=3acdac13&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acdac13"]])

export default __exports__